<template>
  <!-- Job Subscriptions:: This Should be a new page -->
  <section class="job-subscription mb-5">
    <div class="filter">
      <div class="d-flex">
        <div class="grp-1">
          <div class="form-group">
            <input typer="text" class="form-control" placeholder="Keywords" />
          </div>
          <div class="form-group">
            <input typer="text" class="form-control" placeholder="Location" />
          </div>
        </div>
        <div class="grp-2">
          <div class="form-group">
            <input typer="text" class="form-control" placeholder="Company" />
          </div>
          <div class="form-group">
            <select class="form-control">
              <option value disabled selected>Employment</option>
              <option>Self-employment</option>
            </select>
          </div>
        </div>
        <button class="btn btn-success d-flex ml-auto">Add subscription</button>
      </div>
    </div>

    <ul class="list-unstyled hide-on-mobile">
      <li class="d-flex align-items-end">
        <span>HTML, CSS, Solidity, Project Manager</span>
        <span><i class="fas fa-map-marker-alt"></i> Sofia, Bulgaria</span>
        <span><i class="fas fa-building"></i> Comstream</span>
        <span><i class="fas fa-briefcase"></i> Employment</span>
        <i data-toggle="modal" data-target="#editModal" class="fas fa-pen"></i>
        <i data-toggle="modal" data-target="#deleteModal" class="fas fa-times"></i>
      </li>
      <li class="d-flex align-items-end">
        <span>PHP, Laravel, Docker</span>
        <span><i class="fas fa-map-marker-alt"></i> Sofia, Bulgaria</span>
        <span><i class="fas fa-building"></i> Comstream</span>
        <span><i class="fas fa-briefcase"></i> Employment</span>
        <i class="fas fa-pen"></i>
        <i class="fas fa-times"></i>
      </li>
      <li class="d-flex align-items-end">
        <span>JavaScript, React, VueJS</span>
        <span><i class="fas fa-map-marker-alt"></i> Sofia, Bulgaria</span>
        <span><i class="fas fa-building"></i> Comstream</span>
        <span><i class="fas fa-briefcase"></i> Employment</span>
        <i class="fas fa-pen"></i>
        <i class="fas fa-times"></i>
      </li>
      <li class="d-flex align-items-end">
        <span>HTML, CSS, Solidity, Project Manager</span>
        <span><i class="fas fa-map-marker-alt"></i> Sofia, Bulgaria</span>
        <span><i class="fas fa-building"></i> Comstream</span>
        <span><i class="fas fa-briefcase"></i> Employment</span>
        <i class="fas fa-pen"></i>
        <i class="fas fa-times"></i>
      </li>
    </ul>

    <!-- mobile lists replace tables on mobie device -->
    <div class="mobile-lists">
      <ul class="list-unstyled">
        <li>
          <div class="d-flex align-items-center">
            <a class="user" href="#">Comstream</a>
            <span class="job-position ml-auto">Self-Employed</span>
          </div>
          <div class="d-flex align-items-center">
            <span class="location">Sofia, Bulgaria</span>
            <i data-toggle="modal" data-target="#editModal" class="fas fa-pen"></i>
          </div>
          <div class="d-flex align-items-center mt-2">
            <span class="logs">ReactJS</span>
            <span class="logs">Flutter</span>
            <span class="logs">WordPress</span>
            <span class="logs">PHP</span>
          </div>
        </li>
        <li>
          <div class="d-flex align-items-center">
            <a class="user" href="#">Comstream</a>
            <span class="job-position ml-auto">Self-Employed</span>
          </div>
          <div class="d-flex align-items-center">
            <span class="location">Sofia, Bulgaria</span>
            <span class="ml-auto">
              <button class="btn btn-primary"><i class="fas fa-pen"></i></button>
            </span>
          </div>
          <div class="d-flex align-items-center mt-2">
            <span class="logs">ReactJS</span>
            <span class="logs">Flutter</span>
            <span class="logs">WordPress</span>
            <span class="logs">PHP</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- End mobile lists replace tables on mobie device -->
    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModalLabel">Edit subscription</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Keywords"
                value="HTML, CSS, Solidity, Project Manager"
              />
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Location"
                value="Sofia, Bulgaria"
              />
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Company" value="Comstream" />
            </div>
            <div class="form-group">
              <select class="form-control">
                <option value disabled selected>Employment</option>
                <option>Self-employment</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary">Save changes</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete Modal -->
    <div
      class="modal fade"
      id="deleteModal"
      tabindex="-1"
      aria-labelledby="deleteModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Delete Subscription</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>Please confirm that you want to delete this subscription</p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button type="button" class="btn btn-primary">Confirm</button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End job subscriptions -->
</template>

<script>
//import Spinner from '../common/LoadingSpinner/Spinner.vue';

export default {
  /* components: { Spinner }, */
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.job-subscription {
  .filter {
    margin-bottom: 30px;
    font-family: $font-family-sans-lato;
    .grp-1,
    .grp-2 {
      margin-right: 12px;
      .form-group {
        position: relative;
        margin-bottom: 0;
        .form-control {
          font-family: $font-family-sans-lato;
          margin-bottom: 12px;
          color: #777;
        }
      }
    }
    .btn-success {
      align-self: end;
      margin-left: 12px;
      position: relative;
      top: -12px;
    }
    .grp-1 {
      width: 45%;
    }
    .grp-2 {
      flex: 1;
    }
  }
  .list-unstyled {
    li {
      font-family: $font-family-sans-lato;
      font-size: 14px;
      border-bottom: 1px solid #ddd;
      padding: 12px 0;
      position: relative;
      span {
        position: relative;
        width: 19%;
        text-align: center;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        text-transform: uppercase;
        &:first-of-type {
          width: 45%;
          flex-shrink: 0;
          text-align: left;
        }
        i {
          display: block;
          color: #afafaf;
          font-size: 18px;
          margin-bottom: 5px;
        }
      }
      .fa-pen,
      .fa-times {
        color: #afafaf;
        cursor: pointer;
      }
      .fa-times {
        margin-left: 12px;
      }
    }
  }
  .modal-body {
    .form-control {
      height: 38px;
      padding-top: 6px !important;
      font-size: 1rem;
    }
  }
}
.mobile-lists {
  display: none;
}

@media only screen and (max-width: 1251px) {
  .filter {
    .form-group {
      width: 100%;
    }
  }
  .mobile-lists {
    h6 {
      background: #fff;
      margin: 0;
      padding: 12px 15px 0px 15px;
      font-size: 1.2rem;
    }
    display: block;
    width: 100%;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      background: #fff;
      li {
        span {
          margin: 0;
        }
        .d-flex {
          height: auto;
        }
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 12px 0;
        .user {
          display: block;
          font-size: 16px;
          font-weight: 700;
          text-decoration: none;
        }
        .location,
        .job-position,
        .date,
        .rec {
          font-size: 14px;
        }
        .location {
          color: $color-orange;
          margin: 0 !important;
        }
        .job-position {
          color: #666;
        }
        .logs {
          text-transform: uppercase;
          font-size: 12px;
          margin-right: 8px !important;
          font-weight: 600;
          color: #666;
        }
        .btn-primary {
          background: none !important;
          color: #666;
          border: none !important;
          box-shadow: none !important;
          margin-top: 2px;
          &:nth-of-type(2) {
            color: #f02800;
          }
        }
        .fix {
          margin-right: -12px !important;
        }
        &:nth-child(2n) {
          background: #fff;
        }
        .fa-pen {
          right: 5px;
        }
      }
    }
  }
  .logs {
    width: auto !important;
  }
  .job-position {
    text-align: right !important;
  }
  .hide-on-mobile {
    display: none;
  }

  .mobile-lists {
    display: block;
  }
}

@media only screen and (max-width: 768px) {
  .job-subscription {
    .filter {
      .d-flex {
        display: block !important;
      }
      .grp-1 {
        width: 100%;
      }
      .grp-2 {
        width: 100%;
      }
      .btn-success {
        top: 0;
      }
    }
  }
  .hide-on-mobile {
    display: none;
  }

  .logs {
    width: auto !important;
  }
  .job-position {
    text-align: right !important;
  }
}

@media only screen and (max-width: 576px) {
  .job-subscription .filter .grp-1 {
    width: 100%;
  }
  .filter {
    display: block !important;
  }
  .tab-content {
    padding: 0;
  }
  .hide-on-mobile {
    display: none;
  }
  .btn-success {
    margin-top: 12px;
  }
  .logs {
    width: auto !important;
  }
  .job-position {
    text-align: right !important;
  }
}
</style>
